module.exports = __webpack_public_path__ + "img/BR.d39e4e08.jpg";